// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"3f184707","368":"4cda70ca"}[chunkId] + ".chunk.js";
};